import React from "react";
import { Link } from "react-router-dom";

import { AuthorizedItem } from "src/authentication/AuthorizedMenu.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider.tsx";
import Loading from "src/components/DataStates/Loading.tsx";
import TextError from "src/components/Errors/TextError.tsx";
import { useAssignAlertMutation } from "src/graphql/anti-fraud/queries/alerts/mutations/AssignAlertMutation.ts";
import { useT } from "src/internationalization";
import { useCurrentUser } from "src/providers/CurrentUserProvider.tsx";

const AssignAlertButton: React.FC<{ alertId: string }> = ({ alertId }) => {
  const { loading, error, performMutation: assignAlert } = useAssignAlertMutation();
  const { currentUser } = useCurrentUser();
  const t = useT();

  if (loading) return <Loading />;

  return (
    <div>
      <AuthorizedItem
        requiredPermissions={[{ resource: ScopeResource.ALERT, scopes: [Scope.ASSIGN] }]}
      >
        <Link to="" onClick={() => assignAlert({ id: alertId, userId: currentUser.id })}>
          {t("general.actions.assign.to.me")}
        </Link>
      </AuthorizedItem>
      {error && <TextError message={error.message} />}
    </div>
  );
};

export default AssignAlertButton;
